import React from 'react';
import classNames from 'classnames';
import CameraIcon from '../UploadImageWizard/icons/CameraIcon';
import DashedCircleIcon from '../UploadImageWizard/icons/DashedCircleIcon';
import css from './AvatarPlaceholder.css';

export default ({ uploadImageError, onAvatarClick }) => (
    <div className={css.avatarPlaceholderContainer} onClick={() => onAvatarClick()}>
        <DashedCircleIcon
            rootClassName={classNames({
                [css.dashedCircleIcon]: true,
                [css.avatarUploadError]: !!uploadImageError,
            })}
        />
        <div className={css.avatarPlaceholder}>
            <CameraIcon />
            <div className={css.avatarPlaceholderHeading}>
                <span>Profilbild hochladen</span>
            </div>
            <div className={css.avatarPlaceholderFormats}>
                <span>.GIF, .JPG und .PNG Max. 10 MB</span>
            </div>
        </div>
    </div>
);
